import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { hasMoreThan } from '../../../../../play-core/utils/array-helper';
import { loadUdpRecommendedMedia } from '../../../api/load-udp-recommended-media';
import { Swimlane } from '../../../components/Swimlane/Swimlane';
import { SwimlaneTitle } from '../../../components/Swimlane/SwimlaneTitle';
import { Swipeable } from '../../../components/Swipeable/Swipeable';
import { MediaTeaser } from '../../../components/Teaser/MediaTeaser/MediaTeaser';
import { MediaTeaserPlaceholder } from '../../../components/Teaser/MediaTeaser/MediaTeaserPlaceholder';
import { queryKeys } from '../../../config/use-query';
import { useAxios } from '../../../hooks/use-axios';
import { useHydrated } from '../../../hooks/use-hydrated';
import { useAnalyticsId } from '../../../privacy/PrivacyProvider/PrivacyContext';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Recommender = () => {
  const {
    t
  } = useTranslation();
  const axios = useAxios();
  const analyticsId = useAnalyticsId();
  const isHydrated = useHydrated();
  const {
    data: videos,
    error,
    isLoading
  } = useQuery({
    queryKey: [queryKeys.UdpRecommendedMedia(analyticsId || ''), axios],
    queryFn: () => analyticsId ? loadUdpRecommendedMedia(axios, analyticsId) : []
  });
  const showSwimlane = (hasMoreThan(videos, 0) && !error || isLoading) && isHydrated;
  return showSwimlane && /*#__PURE__*/_jsxs(Swimlane, {
    children: [/*#__PURE__*/_jsx(SwimlaneTitle, {
      title: t('home.recommendedForYou')
    }), /*#__PURE__*/_jsx(Swipeable, {
      isPersonalized: true,
      buttonPositionFactor: 9 / 16,
      placeholder: /*#__PURE__*/_jsx(MediaTeaserPlaceholder, {}),
      analyticsTitle: "Recommender",
      children: videos?.map((video, index) => /*#__PURE__*/_jsx(MediaTeaser, {
        media: video,
        index: index
      }, video.id))
    })]
  });
};